import { App, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMCategoryProgressCard,
} from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getProjectName } from "../../../utils/get-plural-of-project-name";
import { makeGetCardCopy } from "../card-copy";

/** Adds the completed-items-per-category-level card (#2222). */
export function addCompletedItemsPerCategoryLevelCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const state = app.getAppState();
  const language = state.language || "en";
  const categoryLabel =
    state.settings?.configuration?.fieldsDefinition?.find(
      (field) => field.fieldName === "dropdownFieldOne"
    )?.label ?? getLocalizedMessage(language, "category");
  const getCardCopy = makeGetCardCopy(app);

  const completedItemsPerCategoryLevelComponent = view.addComponent({
    component: PMCategoryProgressCard,
    layoutProps: {
      componentId: "completedItemsPerCategoryLevelComponentPerProject",
      labels: ["progress"],
      description: getCardCopy(
        language,
        "completedItemsByCategoryLevelPerProject",
        {
          categoryLabel,
        }
      ).description,
      title: getCardCopy(language, "completedItemsByCategoryLevelPerProject", {
        categoryLabel,
      }).title,
    },
  });

  completedItemsPerCategoryLevelComponent.mapLayoutProps(
    ({ language, settings }) => {
      const currentLanguage = language || "en";
      const categoryLabel =
        settings?.configuration?.fieldsDefinition?.find(
          (field) => field.fieldName === "dropdownFieldOne"
        )?.label ?? getLocalizedMessage(currentLanguage, "category");

      return {
        componentId: "completedItemsPerCategoryLevelComponentPerProject",
        labels: ["progress"],
        description: getCardCopy(
          currentLanguage,
          "completedItemsByCategoryLevelPerProject",
          {
            categoryLabel,
          }
        ).description,
        title: getCardCopy(
          currentLanguage,
          "completedItemsByCategoryLevelPerProject",
          {
            categoryLabel,
          }
        ).title,
      };
    }
  );

  completedItemsPerCategoryLevelComponent.mapState(
    ({ currentReport, settings, language }) => {
      const currentLanguage = language || "en";
      const categoryLabel =
        settings?.configuration?.fieldsDefinition?.find(
          (field) => field.fieldName === "dropdownFieldOne"
        )?.label ?? getLocalizedMessage(currentLanguage, "category");
      const title = getLocalizedCardCopy(
        currentLanguage,
        "completedItemsByCategoryLevelPerProject",
        {
          itemName: getItemName(
            settings?.configuration?.itemName,
            currentLanguage
          ),
          itemNamePlural: getPluralOfItemName(
            settings?.configuration?.itemName,
            currentLanguage
          ),
          projectName: getProjectName(
            settings?.configuration?.projectName,
            currentLanguage
          ),
          categoryLabel,
        }
      ).title;

      return {
        label: title,
        title,

        showInfoIcon: false,
        showMenuIcon: false,
        data:
          currentReport?.project?._calculated
            ?.categoryCountsForCompletedItemsPerCategoryLevel ?? [],
      };
    }
  );

  completedItemsPerCategoryLevelComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemBasic")
        .find((field) => field.fieldName === "dropdownFieldOne")?.enabled ===
      true
  );
}
